import { useEffect } from 'react';

import isUserTypeCustomer from 'src/auth/helper';
import FlashesStore from 'src/stores/FlashesStore';

/**
 * Guards a customer-only trade-rule route. When the loaded viewer is not a
 * customer, it flashes an error and redirects to `/properties`. The guard is a
 * no-op until the viewer user has loaded (so it does not fire during loading).
 * @param {object} params - Parameters.
 * @param {object} params.intl - `react-intl` instance used to format the error message.
 * @param {object} params.router - React Router object providing navigation capabilities.
 * @param {string} params.userType - The viewer's user type.
 * @param {object} params.viewerUser - The viewer user object; the guard waits until it is present.
 */
const useCustomerOnlyRoute = ({
  intl, router, userType, viewerUser,
}) => {
  useEffect(() => {
    if (!router || !viewerUser || isUserTypeCustomer(userType)) {
      return;
    }

    const errorMsg = intl.formatMessage({ id: 'trade_rule.hooks.only_customer_users_can_view_proposals.message', defaultMessage: 'Only customers can view their proposals.' });
    FlashesStore.flash(FlashesStore.ERROR, errorMsg);
    router.replace('/properties');
  }, [intl, router, userType, viewerUser]);
};

export default useCustomerOnlyRoute;
